<template>
  <div
    class="mt-8 w-full max-w-md mx-auto p-6"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span class="sr-only">Cargando…</span>

    <div class="animate-pulse space-y-6">
      <div>
        <div class="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-2"></div>
        <div class="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
      </div>

      <div>
        <div class="h-4 bg-gray-200 rounded w-20 mb-2"></div>
        <div class="h-9 bg-gray-200 rounded-md"></div>
      </div>

      <div class="flex items-center my-4">
        <div class="flex-1 h-px bg-gray-200"></div>
        <div class="px-3 h-4 bg-gray-200 rounded w-20"></div>
        <div class="flex-1 h-px bg-gray-200"></div>
      </div>

      <div class="space-y-3">
        <div class="h-9 bg-gray-100 rounded-md border border-gray-200"></div>
      </div>

      <div class="h-9 bg-primary/70 rounded-md"></div>
    </div>
  </div>
</template>
